import { SubjectItem as SubjectItemGenerated } from 'elegislativa-frontend-ts-axios';

interface SubjectItem {
  uuid: string;
  nazov: string;
}

function mapSubject(subject: SubjectItemGenerated): SubjectItem | undefined {
  if (!subject) {
    return undefined;
  }
  return {
    uuid: subject.uuid,
    nazov: subject.celeMeno,
  };
}

export { SubjectItem, mapSubject };
